import { Box, Card, CardActions, CardContent, CardHeader, Chip, Tooltip, Typography } from "@mui/material";
import { DataTypes, Priority, ServiceRequest, ServiceRequestStatus, ViewServiceRequestData } from "../../Types/UnitFeatureTypes";
import { useNavigate } from "react-router-dom";

const DisplayServiceRequestCard: React.FC<{ item: ViewServiceRequestData }> = ({ item }) => {
    const navigate = useNavigate();

    const getPriorityColor = (priority: Priority) => {
        switch (priority) {
            case Priority.HIGH:
                return '#fc585d';
            case Priority.MEDIUM:
                return '#FCB15A';
            case Priority.LOW:
                return 'cyan';
            case Priority.LOWEST:
                return 'green';
            case Priority.CRITICAL:
                return 'red';
            default:
                return 'white';
        }
    }

    const handleOnSericeRequest = () => {
        navigate(`/viewServiceRequest`, { state: { id: item.id, type: DataTypes.SERVICE_REQUEST } });
    }

    const priorityColor = getPriorityColor(item.priority);

    if (item.status === ServiceRequestStatus.CANCELLED || item.status === ServiceRequestStatus.COMPLETED) {
        return <></>
    }

    return (
        <Card sx={{ borderRadius: 3, minHeight: 200, minWidth: 350, borderLeft: `5px solid ${priorityColor}` }} onClick={handleOnSericeRequest}>
            <Tooltip title={item.title}>
                <CardHeader 
                    title={<Typography variant="h5" sx={{ maxWidth: 245, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</Typography>} 
                    subheader={<Typography variant="body2" color="textSecondary"> Created on {new Date(item.created_on).toDateString()}</Typography>} 
                    sx={{ height: 60, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    action={
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: 60 }}>
                            <Tooltip title={<><b>Priority: </b> <b style={{color: priorityColor}}>{item.priority}</b></>}>
                                <Chip label={item.priority} sx={{ fontWeight: 'bold', backgroundColor: priorityColor }} />
                            </Tooltip>
                        </Box>
                    }
                />
            </Tooltip>
            <CardContent>
                <Tooltip title={item.description}>
                    <Typography variant="h6" color="textSecondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {item.description}
                    </Typography>
                </Tooltip>
                {/* <Typography variant="body2" sx={{fontWeight: 'bold'}} color={priorityColor}>
                    Priority: {item.priority}
                </Typography> */}
            </CardContent>
            <CardActions>
                <Typography variant="body2" color="textSecondary">
                    Estimated Resolution Date: {item.estimated_resolution_date ? new Date(item.estimated_resolution_date).toDateString() : 'N/A'}
                </Typography>
            </CardActions>
        </Card>
    );
}

export default DisplayServiceRequestCard;